@if (formField(); as field) {
  <app-radio
    [(value)]="value"
    [required]="field.required ? 'true' : 'false'"
    [label]="field.label"
    [options]="field.options"
  />
}
